if (!customElements.get("custom-bundle")) {
  customElements.define(
    "custom-bundle",
    class CustomBundle extends HTMLElement {
        constructor() {
            super();
            this.planSelectors = this.querySelectorAll(`.custom-selling-plan-wrapper-item input[name="plan-selector"]`);
            this.variantSelectors = this.querySelectorAll(`.custom-variant-selection-bundle`);
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.button = this.querySelector(".custom-bundle-atc");
            this.mainProductId = this.dataset.pid;
            this.initEventListeners();
        }
        initEventListeners(){
            this.planSelectors.forEach((el) => {
                el.addEventListener("change",this.onPlanChange.bind(this));
            });
             this.variantSelectors.forEach((el) => {
                el.addEventListener("change",this.onVariantChange.bind(this));
            });
            this.button.addEventListener("click",this.addBundle.bind(this));
        }
        getSelectedPlanElement(){
            return this.querySelector(`.custom-selling-plan-wrapper-item input[name="plan-selector"]:checked`);
        }
        getSelectedVariantElement(){
            return this.querySelector(`.custom-variant-selection-bundle:checked`);
        }
        onVariantChange(evt){
             this.updateStateAndValue();
        }
        onPlanChange(evt){
            this.updateStateAndValue();
        }
        updateStateAndValue(){
            const selectedPlanElement = this.getSelectedPlanElement();
            const selectedVariantElement = this.getSelectedVariantElement();
            this.querySelectorAll(".main-variant-wrapper-item").forEach(el => el.classList.remove("active-variant-selected"));
            selectedVariantElement.closest(".main-variant-wrapper-item").classList.add("active-variant-selected");
            if(selectedPlanElement.value == 'subscribe'){
                const numberofproduct  = +selectedVariantElement.dataset.freenumber;
                this.querySelectorAll('.variant-gfit-wrapper-item').forEach((el) => {
                    
                    /*if(el.dataset.number <= numberofproduct){
                         el.classList.remove("not-active");
                    }else if(el.dataset.number == 2 && numberofproduct == 0){
                         el.classList.remove("not-active");
                    }else{
                         el.classList.add("not-active");
                    }*/
                    /*
                    if(this.mainProductId == 15242855514498){
                        if(el.dataset.number == 4 && numberofproduct == 1){
                            el.classList.remove("not-active");
                        }else{
                            if(el.dataset.number <= numberofproduct && numberofproduct > 1){
                                el.classList.remove("not-active");
                            }else{
                                el.classList.add("not-active");
                            }
                            
                        }
                    }else{
                        if(el.dataset.number <= numberofproduct){
                            el.classList.remove("not-active");
                        }else{
                            el.classList.add("not-active");
                        }
                    }*/
                    if(el.dataset.number <= numberofproduct){
                        el.classList.remove("not-active");
                    }else{
                        el.classList.add("not-active");
                    }
                    
                });
                this.querySelector(".onetime-wrapper-note").classList.add("hidden");
                this.querySelector(".subscribe-note-wrapper").classList.remove("hidden");
                this.querySelectorAll(".price.onetime").forEach(el => el.classList.add("hidden"));
                this.querySelectorAll(".price.subscribe").forEach(el => el.classList.remove("hidden"));
                this.querySelectorAll(".custom-variant-saving-badge.subscribe").forEach(el => el.classList.remove("hidden"));
                this.querySelectorAll(".custom-variant-saving-badge.onetime").forEach(el => el.classList.add("hidden"));
                this.querySelectorAll(".gift-wrapper-title-image .onetime").forEach(el => el.classList.add("hidden"));
                this.querySelectorAll(".gift-wrapper-title-image .subscribe").forEach(el => el.classList.remove("hidden"));
                const priceElementHtml = document.querySelector(`.custom-price-object[data-vid="${selectedVariantElement.value}"]`);
                if(priceElementHtml){
                    this.button.querySelector(".atc-price-wrapper").innerHTML = priceElementHtml.querySelector(".subprice-wrapper").innerHTML;
                }
                /*this.querySelector(".subscribe-note-wrapper .variant-number-counter").textContent = selectedVariantElement.dataset.unitcount;
                this.querySelector(".subscribe-note-wrapper .variant-price-html").textContent = selectedVariantElement.dataset.sprice;*/
                this.querySelector(".subscribe-note-wrapper ul li:first-child").textContent = selectedVariantElement.dataset.fixtext;

                const priceElemenForPlanObject = document.querySelector(`.custom-price-object-for-plan-selector[data-vid="${selectedVariantElement.value}"]`);
                if(priceElemenForPlanObject){
                    this.querySelector(".custom-selling-plan-wrapper-item.subscribe-item .plan-price").innerHTML = priceElemenForPlanObject.querySelector(".s-price-object").innerHTML;
                }
            }else{
                this.querySelectorAll(".custom-variant-saving-badge.subscribe").forEach(el => el.classList.add("hidden"));
                this.querySelectorAll(".custom-variant-saving-badge.onetime").forEach(el => el.classList.remove("hidden"));
                this.querySelectorAll(".gift-wrapper-title-image .onetime").forEach(el => el.classList.remove("hidden"));
                this.querySelectorAll(".gift-wrapper-title-image .subscribe").forEach(el => el.classList.add("hidden"));
                 this.querySelectorAll(".price.onetime").forEach(el => el.classList.remove("hidden"));
                 this.querySelectorAll(".price.subscribe").forEach(el => el.classList.add("hidden"));
                this.querySelector(".onetime-wrapper-note").classList.remove("hidden");
                this.querySelector(".subscribe-note-wrapper").classList.add("hidden");
                this.querySelectorAll('.variant-gfit-wrapper-item').forEach((el) => {
                    el.classList.add("not-active");
                });
                const priceElementHtml = document.querySelector(`.custom-price-object[data-vid="${selectedVariantElement.value}"]`);
                if(priceElementHtml){
                    this.button.querySelector(".atc-price-wrapper").innerHTML = priceElementHtml.querySelector(".oneprice-wrapper").innerHTML;
                }
                const priceElemenForPlanObject = document.querySelector(`.custom-price-object-for-plan-selector[data-vid="${selectedVariantElement.value}"]`);
                if(priceElemenForPlanObject){
                    this.querySelector(".custom-selling-plan-wrapper-item.onetime-item .plan-price").innerHTML = priceElemenForPlanObject.querySelector(".o-price-object").innerHTML;
                }
            }
        }
        addBundle(evt){
            evt.preventDefault();
            let items = [];
            const selectedPlanElement = this.getSelectedPlanElement();
            const selectedVariantElement = this.getSelectedVariantElement();
            const bundleId = new Date().getTime(); 
            let planId = selectedVariantElement.dataset.sellingplan;
            
            if(selectedPlanElement.value == 'subscribe'){
                
                const numberofproduct  = +selectedVariantElement.dataset.freenumber;
                this.querySelectorAll('.variant-gfit-wrapper-item').forEach((el) => {
                    /*
                    if(this.mainProductId == 15242855514498){
                        if(el.dataset.number == 4 && numberofproduct == 1){
                            items.push({
                                    id:el.dataset.gid,
                                    quantity:1,
                                    properties:{
                                        "_ismain":0,
                                        "_bundleid":bundleId
                                    }
                                });
                        }else{
                            if(el.dataset.number <= numberofproduct && numberofproduct > 1){
                                items.push({
                                    id:el.dataset.gid,
                                    quantity:1,
                                    properties:{
                                        "_ismain":0,
                                        "_bundleid":bundleId
                                    }
                                });
                            }
                            
                        }
                    }else{
                        if(el.dataset.number <= numberofproduct){
                            items.push({
                                id:el.dataset.gid,
                                quantity:1,
                                properties:{
                                    "_ismain":0,
                                    "_bundleid":bundleId
                                }
                            });
                        }
                    }
                    */

                     if(el.dataset.number <= numberofproduct){
                            items.push({
                                id:el.dataset.gid,
                                quantity:1,
                                properties:{
                                    "_ismain":0,
                                    "_bundleid":bundleId
                                }
                            });
                        }
                });
                 items.push({
                    id:selectedVariantElement.value,
                    quantity:1,
                    selling_plan:planId,
                    properties:{
                        "_ismain":1,
                        "_bundleid":bundleId
                    }
                });
            }else{
                items.push({
                    id:selectedVariantElement.value,
                    quantity:1
                });
            }
            if(items.length > 0){
                this.button.disabled = true;
                const formData = {
                    'items': items,
                    sections: this.cart.getSectionsToRender().map((section) => section.id),
                    sections_url: window.location.pathname
                };
                fetch(`/cart/add.js`,{
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                    .then((response) => response.json())
                    .then((response) => {
                        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: this.dataset.pid,
                            cartData: response,
                        }).then(() => {
                            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                        });
                        CartPerformance.measure("add:paint-updated-sections", () => {
                            this.cart.renderContents(response);
                        });
                    
                })
                .catch(error => {
                    console.error('Error:', error);
                    this.button.disabled = false;
                }).finally(() => {
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    CartPerformance.measureFromEvent("add:user-action", evt);
                    this.button.disabled = false;
                });
            }
        }
        connectedCallback() {
            this.updateStateAndValue();
        }
    }
  );
}